import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Scroll-triggered reveal (once).
export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Staggered container: children with class use `RevealItem`.
export const RevealGroup = ({ children, className = "", stagger = 0.08, delay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: stagger, delayChildren: delay } },
    }}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, className = "", y = 28 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

// Line-by-line masked text reveal. `lines` = array of strings or React nodes.
export const MaskText = ({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.11,
  animate = "onLoad", // "onLoad" | "inView"
}) => {
  const commonSpanProps =
    animate === "inView"
      ? { whileInView: { y: "0%" }, viewport: { once: true, margin: "-60px" }, initial: { y: "115%" } }
      : { animate: { y: "0%" }, initial: { y: "115%" } };

  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            transition={{ duration: 0.95, delay: delay + i * stagger, ease: EASE }}
            {...commonSpanProps}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
